import axios from 'axios'

const baseURL = process.env.VUE_APP_API_URL

const getAPI = axios.create({
    baseURL,
    timeout: 20000
})

export { getAPI }
